<ng-container *ngIf="!isLoading">
  <div *ngFor="let dateItem of monthEvents" class="date-box">
    <div class="date-label">{{ dateItem.date | date: "EEEE, dd MMMM yyyy" }}</div>
    <div class="events-list">
      <app-month-event-item *ngFor="let event of dateItem.events" [event]="event" [studentCalendarFilters]="studentCalendarFilters" 
        [notificationHeader]="notificationHeader" [submissionLabel]="submissionLabel" [atHourLabel]="atHourLabel"/>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isLoading">
  <div *ngFor="let _ of [].constructor(2)" class="date-box">
    <app-skeleton class="date-label" [type]="'text'" [symbolsCount]="16"></app-skeleton>

    <div class="events-list">
      <app-month-event-item *ngFor="let _ of [].constructor(2)" [isLoading]="true" />
    </div>
  </div>
</ng-container>
